import React from 'react'
// import { createRoot } from 'react-dom/client'
import { render } from "react-dom";
import { Provider } from 'react-redux'
import './index.css'
import ApplicationRoute from 'routes'
import store from './ducks'
import reportWebVitals from './reportWebVitals'
import './devTools/ReactotronConfig'

const container = document.getElementById('root');

render(
  <Provider store={store}>
      <ApplicationRoute />
  </Provider>, container);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
